//jquery ui
import 'jquery-ui/ui/widgets/datepicker.js'; 
import 'jquery-ui/ui/widgets/sortable.js'; 
import 'trumbowyg/dist/trumbowyg.min'; 
	$.trumbowyg.svgPath = '/node_modules/trumbowyg/dist/ui/icons.svg'; //required by trumbowyg

import './runtime/registerMap.js';
import './runtime/domReadyListeners.js'; 
import './runtime/adminReadyListeners.js'; 
import './runtime/mobileListeners.js'; 
import './runtime/urlRuntimeApiCalls.js'; 
import DOMPurify from 'dompurify'; 
